// extracted by mini-css-extract-plugin
export default {"content":"Liquidity_content__WUrYo"};